
import { cn } from "@/lib/utils";
import { CertificateLogo } from "../CertificateLogo";

interface CertificateHeaderProps {
  style: Record<string, string>;
}

export function CertificateHeader({ style }: CertificateHeaderProps) {
  return (
    <div className="text-center space-y-2 sm:space-y-3 w-full animate-fade-in" style={{ animationDelay: "100ms" }}>
      <div className="flex justify-center mb-2">
        <CertificateLogo />
      </div>
      <div className="space-y-1 sm:space-y-2">
        <h1 className={cn(
          "font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent",
          "text-base sm:text-xl md:text-2xl leading-tight",
          style.titleFont,
          "transition-all duration-300 hover:scale-105"
        )}>
          Achievement Certificate
        </h1>
        <p className={cn(
          "italic text-xs sm:text-sm md:text-base",
          style.contentFont
        )}>
          My goals, my rules.
        </p>
      </div>
    </div>
  );
}
